import script from "./VGroupCriterion.vue?vue&type=script&setup=true&lang=js"
export * from "./VGroupCriterion.vue?vue&type=script&setup=true&lang=js"

import "./VGroupCriterion.vue?vue&type=style&index=0&id=63670c20&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63670c20"]])

export default __exports__